import RatingStars from "@/components/base/RatingStars";
import type { Review } from "@/types";

export default function ReviewList({ reviews }: { reviews: Review[] }) {
  if (reviews.length === 0) {
    return (
      <p className="font-label text-sm text-foreground-500">暂无影评</p>
    );
  }
  return (
    <div className="space-y-4">
      {reviews.map((review) => (
        <div
          key={review.id}
          className="rounded-lg border border-background-200 bg-background-50 p-4"
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 font-label text-xs font-semibold text-secondary-900">
                {review.author.slice(0, 1)}
              </span>
              <span className="font-label text-sm font-semibold text-foreground-900">
                {review.author}
              </span>
            </div>
            <span className="font-label text-xs text-foreground-500">
              {review.date}
            </span>
          </div>
          <div className="mt-2">
            <RatingStars value={review.rating * 2} />
          </div>
          <p className="mt-2 font-label text-sm leading-relaxed text-foreground-700">
            {review.text}
          </p>
        </div>
      ))}
    </div>
  );
}